import Flickity from 'flickity';
import { preloadImagesIn } from "../utils";
class highlights {
  constructor(context) {
    context.querySelectorAll('[data-highlights]').forEach(element => {
      new Flickity(element, {
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 5000,
        cellAlign: 'left'
      });
    });

    context.querySelectorAll('[data-highlights-academy]').forEach(element => {
      new Flickity(element, {
        cellAlign: 'left',
        pageDots: true,
        contain: true,
        prevNextButtons: false,
        autoPlay: 5000
      });
    });

    context.querySelectorAll('[data-videos-slider]').forEach(element => {
      new Flickity(element, {
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        cellAlign: 'left'
      });
    });

    context.querySelectorAll('[data-medias-slider]').forEach(element => {
      preloadImagesIn(element).then(_ => {
        new Flickity(element, {
          pageDots: false,
          contain: true,
          prevNextButtons: true,
          cellAlign: 'left'
        });
      });
    });
  }
};

export default highlights;